<template>
  <a-card style="width:100%; height: 432px" class="bg-white" :loading="loading">
    <tk-flex middle between style="height: 60px">
      <div class="font-14">粮虫数量变动</div>
      <tk-flex>
        <LevleSelect style="width: 120px" v-model="level" class="m-r-10" />
        <a-month-picker
          v-model="date"
          :allowClear="false"
          style="width: 120px"
        />
      </tk-flex>
    </tk-flex>
    <div class="chat-wrap">
      <ve-chart :options="options" />
    </div>
  </a-card>
</template>

<script>
import LevleSelect from '../../levleSelect'
import { mapGetters } from 'vuex'
import moment from 'moment'

// 获取之前15天的日期格式
export default {
  components: {
    LevleSelect
  },
  data () {
    return {
      loading: true,
      level: undefined,
      date: moment(),
      options: {
        title: {
          show: false
        },
        tooltip: {},
        dataset: {
          source: [[], []]
        },
        xAxis: [{ type: 'category', gridIndex: 0 }],
        yAxis: [{ gridIndex: 0 }],
        grid: [{ bottom: '10%', left: 60, right: 50 }],
        series: [
          {
            type: 'line',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#2FBF79' }
          }
        ]
      }
    }
  },
  watch: {
    level () {
      this.getData()
    },
    date () {
      this.getData()
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    hierarchyFilter () {
      if (this.level) {
        return {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.level }
            },
            className: 'hierarchy'
          }
        }
      } else {
        return {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.userLevelTag }
            },
            className: 'hierarchy'
          }
        }
      }
    },
    nowYear () {
      return this.date.year()
    },
    dateList () {
      const startTime = moment(this.date).startOf('month')
      const endTime = moment(this.date).endOf('month')
      const days = endTime.diff(startTime, 'day') + 1
      const arr = []
      for (let index = 0; index < days; index++) {
        const currentTime = moment(startTime).add(index, 'days')
        arr.push(currentTime)
      }
      return arr
    },
    datesArr () {
      return this.dateList.map(
        element => `${element.month() + 1}.${element.date()}`
      )
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      const arr = this.dateList.map(element => {
        return this.getNumByDate(element)
      })
      this.loading = true
      const res = await Promise.all(arr)
      this.loading = false
      this.undateOptions(res)
    },
    undateOptions (nums) {
      const year = this.nowYear
      this.options = {
        title: {
          show: false
        },
        tooltip: {
          formatter (params) {
            const [month, day] = params.name.split('.')
            const line1 = `<div style="font-size: 12px; color: #666A70;">${year}年${month}月${day}日</div>`
            const line2 = `<div style="font-size: 12px; color: #363B45;">粮虫数量：${params.value[1]}</div>`
            return line1 + line2
          }
        },
        dataset: {
          source: [
            ['日期', ...this.datesArr],
            ['粮虫数量', ...nums]
          ]
        },
        xAxis: [{ type: 'category', gridIndex: 0 }],
        yAxis: [{ gridIndex: 0 }],
        grid: [{ bottom: '15%', left: 60, right: 10, top: 10 }],
        series: [
          {
            type: 'line',
            seriesLayoutBy: 'row',
            itemStyle: { color: '#2FBF79' }
          }
        ]
      }
    },
    async getNumByDate (date) {
      const res = await this.$tkParse.get('/classes/dayStoreResult', {
        params: {
          where: {
            hierarchy: this.hierarchyFilter,
            date: {
              $gt: moment(date)
                .startOf('day')
                .toISOString(),
              $lte: moment(date)
                .endOf('day')
                .toISOString()
            }
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      let num = 0
      res.data.results.forEach(element => {
        num += element.bugNum || 0
      })
      return num
    }
  }
}
</script>
<style lang="scss">
.chat-wrap {
  width: 100%;
  height: 324px;
  background-color: #fff;
  box-sizing: border-box;
}
.chat-wrap .echarts {
  width: 100%;
  height: 100%;
}
</style>
